import type { ReactElement, SVGProps } from 'react';

/**
 * Icones das redes sociais, em SVG inline.
 *
 * Inline e nao de uma biblioteca: sao dez glifos simples, e uma
 * dependencia de icones traria centenas que nunca usariamos. O CSP dos
 * artifacts tambem bloqueia imagens externas.
 *
 * `currentColor` em todos: assim herdam a cor do texto e funcionam nos
 * dois modos sem duplicacao.
 */
type P = SVGProps<SVGSVGElement>;

const base = (p: P) => ({
  width: 16, height: 16, viewBox: '0 0 24 24',
  fill: 'currentColor', 'aria-hidden': true, ...p,
});

export const IconeYoutube = (p: P) => (
  <svg {...base(p)}><path d="M23 12s0-3.9-.5-5.8a3 3 0 0 0-2.1-2.1C18.5 3.6 12 3.6 12 3.6s-6.5 0-8.4.5A3 3 0 0 0 1.5 6.2C1 8.1 1 12 1 12s0 3.9.5 5.8a3 3 0 0 0 2.1 2.1c1.9.5 8.4.5 8.4.5s6.5 0 8.4-.5a3 3 0 0 0 2.1-2.1C23 15.9 23 12 23 12ZM9.9 15.4V8.6l5.8 3.4-5.8 3.4Z"/></svg>
);

export const IconeInstagram = (p: P) => (
  <svg {...base({ fill: 'none', ...p })}>
    <rect x="2.5" y="2.5" width="19" height="19" rx="5.5" stroke="currentColor" strokeWidth="1.8"/>
    <circle cx="12" cy="12" r="4.2" stroke="currentColor" strokeWidth="1.8"/>
    <circle cx="17.6" cy="6.4" r="1.2" fill="currentColor"/>
  </svg>
);

export const IconeX = (p: P) => (
  <svg {...base(p)}><path d="M17.7 3h3.3l-7.2 8.3L22 21h-6.6l-5.2-6.8L4.2 21H.9l7.7-8.8L1 3h6.8l4.7 6.2L17.7 3Zm-1.2 16h1.8L7.6 4.9H5.7L16.5 19Z"/></svg>
);

export const IconeTiktok = (p: P) => (
  <svg {...base(p)}><path d="M16.6 5.8a4.8 4.8 0 0 1-1.1-3.1h-3.2v12.6a2.6 2.6 0 1 1-1.9-2.5V9.5a5.8 5.8 0 1 0 5.1 5.7V9.1a7.9 7.9 0 0 0 4.4 1.4V7.3a4.7 4.7 0 0 1-3.3-1.5Z"/></svg>
);

export const IconeTelegram = (p: P) => (
  <svg {...base(p)}><path d="M21.9 4.3 18.6 20c-.2 1.1-.9 1.4-1.8.9l-4.9-3.6-2.4 2.3c-.3.3-.5.5-1 .5l.4-5 9.1-8.2c.4-.4-.1-.6-.6-.2L6.2 13 1.3 11.5c-1.1-.3-1.1-1 .2-1.5l19-7.3c.9-.3 1.7.2 1.4 1.6Z"/></svg>
);

export const IconeDiscord = (p: P) => (
  <svg {...base(p)}><path d="M19.6 5.6A16 16 0 0 0 15.6 4.4l-.2.4a15 15 0 0 1 3.5 1.1 12.6 12.6 0 0 0-10.8 0 15 15 0 0 1 3.5-1.1l-.2-.4A16 16 0 0 0 7.4 5.6C4.9 9.3 4.2 12.9 4.5 16.4a16.1 16.1 0 0 0 4.9 2.5l.6-1.1a10.4 10.4 0 0 1-1.6-.8l.4-.3a11.5 11.5 0 0 0 9.8 0l.4.3a10.4 10.4 0 0 1-1.6.8l.6 1.1a16.1 16.1 0 0 0 4.9-2.5c.4-4.1-.7-7.7-2.9-10.8ZM9.7 14.3c-1 0-1.7-.9-1.7-1.9s.8-1.9 1.7-1.9 1.8.9 1.7 1.9c0 1-.8 1.9-1.7 1.9Zm4.6 0c-1 0-1.7-.9-1.7-1.9s.8-1.9 1.7-1.9 1.8.9 1.7 1.9c0 1-.7 1.9-1.7 1.9Z"/></svg>
);

export const IconeTwitch = (p: P) => (
  <svg {...base(p)}><path d="M4.3 2 2.5 6.5v14h5V24h3l2.5-3.5h4L22 15V2H4.3Zm15.9 12.3-3 3h-4l-2.5 2.5V17.3H6.9V4h13.3v10.3ZM17 7.3v5.4h-2V7.3h2Zm-5 0v5.4h-2V7.3h2Z"/></svg>
);

export const IconeLinkedin = (p: P) => (
  <svg {...base(p)}><path d="M20.4 2H3.6A1.6 1.6 0 0 0 2 3.6v16.8A1.6 1.6 0 0 0 3.6 22h16.8a1.6 1.6 0 0 0 1.6-1.6V3.6A1.6 1.6 0 0 0 20.4 2ZM8.1 18.8H5.2V9.4h2.9v9.4ZM6.6 8.1a1.7 1.7 0 1 1 0-3.4 1.7 1.7 0 0 1 0 3.4Zm12.2 10.7h-2.9v-4.6c0-1.1 0-2.5-1.5-2.5s-1.8 1.2-1.8 2.4v4.7H9.8V9.4h2.7v1.3h.1a3 3 0 0 1 2.7-1.5c2.9 0 3.5 1.9 3.5 4.4v5.2Z"/></svg>
);

export const IconeFacebook = (p: P) => (
  <svg {...base(p)}><path d="M22 12a10 10 0 1 0-11.6 9.9v-7H7.9V12h2.5V9.8c0-2.5 1.5-3.9 3.8-3.9 1.1 0 2.2.2 2.2.2v2.5h-1.3c-1.2 0-1.6.8-1.6 1.6V12h2.8l-.4 2.9h-2.4v7A10 10 0 0 0 22 12Z"/></svg>
);

export const IconeSite = (p: P) => (
  <svg {...base({ fill: 'none', ...p })}>
    <circle cx="12" cy="12" r="9.2" stroke="currentColor" strokeWidth="1.8"/>
    <path d="M2.8 12h18.4M12 2.8c2.3 2.5 3.5 5.8 3.5 9.2s-1.2 6.7-3.5 9.2c-2.3-2.5-3.5-5.8-3.5-9.2s1.2-6.7 3.5-9.2Z"
          stroke="currentColor" strokeWidth="1.8"/>
  </svg>
);

export const ICONE_REDE: Record<string, (p: P) => ReactElement> = {
  youtube: IconeYoutube,
  instagram: IconeInstagram,
  x: IconeX,
  tiktok: IconeTiktok,
  telegram: IconeTelegram,
  discord: IconeDiscord,
  twitch: IconeTwitch,
  linkedin: IconeLinkedin,
  facebook: IconeFacebook,
  site: IconeSite,
};
